(function () {
  'use strict';

  var STORAGE_KEY = 'od_marketing_attribution_v1';
  var RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
  var PARAMETER_NAMES = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_content',
    'utm_term',
    'utm_source_platform',
    'meta_adset_id',
    'meta_ad_id',
    'meta_placement'
  ];

  function clean(value, maximumLength) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maximumLength || 120);
  }

  function marketingProcessingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return true;
    return privacy.marketingAllowed();
  }

  function readStoredAttribution() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!stored || !stored.expiresAt || Date.now() > stored.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return stored;
    } catch (error) {
      return null;
    }
  }

  function writeStoredAttribution(attribution) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (error) {
      return;
    }
  }

  function touchFromCurrentUrl() {
    var parameters = new URLSearchParams(window.location.search);
    var hasMarketingParameter = PARAMETER_NAMES.some(function (name) {
      return parameters.has(name) && clean(parameters.get(name));
    });
    if (!hasMarketingParameter) return null;

    var touch = {
      captured_at: new Date().toISOString(),
      landing_page: clean(window.location.pathname, 180)
    };
    PARAMETER_NAMES.forEach(function (name) {
      var value = clean(parameters.get(name));
      if (value) touch[name] = value;
    });
    return touch;
  }

  function formatTouch(touch) {
    var parts = [];
    if (touch.utm_source || touch.utm_medium) {
      parts.push([touch.utm_source, touch.utm_medium].filter(Boolean).join(' / '));
    }
    if (touch.utm_campaign) {
      parts.push('Campagna: ' + touch.utm_campaign + (touch.utm_id ? ' [' + touch.utm_id + ']' : ''));
    } else if (touch.utm_id) {
      parts.push('ID campagna/flusso: ' + touch.utm_id);
    }
    if (touch.utm_content) parts.push('Inserzione/email: ' + touch.utm_content);
    if (touch.utm_term) parts.push('Gruppo inserzioni: ' + touch.utm_term);
    if (touch.meta_ad_id) parts.push('Ad ID: ' + touch.meta_ad_id);
    if (touch.meta_adset_id) parts.push('Ad set ID: ' + touch.meta_adset_id);
    if (touch.meta_placement) parts.push('Posizionamento: ' + touch.meta_placement);
    if (touch.utm_source_platform) parts.push('Piattaforma: ' + touch.utm_source_platform);
    return clean(parts.join(' | '), 500);
  }

  function cartAttributes(attribution) {
    return {
      'Attribuzione - primo contatto': formatTouch(attribution.first),
      'Attribuzione - ultimo contatto': formatTouch(attribution.last),
      'Pagina ingresso - primo contatto': attribution.first.landing_page,
      'Pagina ingresso - ultimo contatto': attribution.last.landing_page,
      'Data - primo contatto': attribution.first.captured_at,
      'Data - ultimo contatto': attribution.last.captured_at
    };
  }

  function attributesDiffer(current, expected) {
    return Object.keys(expected).some(function (key) {
      return current[key] !== expected[key];
    });
  }

  function syncCart(attribution) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var expected = cartAttributes(attribution);
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!attributesDiffer(cart.attributes || {}, expected)) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: expected })
        });
      })
      .catch(function () { return null; });
  }

  function captureAndSync() {
    if (!marketingProcessingAllowed()) return;

    var currentTouch = touchFromCurrentUrl();
    var attribution = readStoredAttribution();
    if (currentTouch) {
      attribution = attribution || { first: currentTouch };
      attribution.last = currentTouch;
      attribution.expiresAt = Date.now() + RETENTION_MS;
      writeStoredAttribution(attribution);
    }
    if (attribution && attribution.first && attribution.last) syncCart(attribution);
  }

  function initialize() {
    document.addEventListener('visitorConsentCollected', captureAndSync);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { captureAndSync(); }
      );
    } else {
      captureAndSync();
    }
  }

  initialize();
})();


(function () {
  'use strict';

  var PIXEL_SELECT_EVENT = 'od_select_item';
  var PIXEL_CART_EVENT = 'od_view_cart';
  var GA4_MEASUREMENT_ID = 'G-4Z8H023HS9';
  var CARD_SELECTOR = 'product-card, vertical-product-card, horizontal-product-card';
  var PRODUCT_LINK_SELECTOR = [
    'a.product-card__link[href*="/products/"]',
    'a.vertical-product-card__link[href*="/products/"]',
    'a.horizontal-product-card__link[href*="/products/"]'
  ].join(', ');
  var initialized = false;

  function clean(value, maximumLength) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maximumLength || 160);
  }

  function compact(object) {
    Object.keys(object).forEach(function (key) {
      if (object[key] === '' || object[key] === null || typeof object[key] === 'undefined') {
        delete object[key];
      }
    });
    return object;
  }

  function productHandle(link) {
    try {
      var match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? clean(match[1], 120) : '';
    } catch (error) {
      return '';
    }
  }

  function parsePrice(value) {
    var match = clean(value, 80).match(/\d{1,3}(?:[.\s]\d{3})*(?:,\d{1,2})|\d+(?:\.\d{1,2})?/);
    if (!match) return null;
    var normalized = match[0];
    if (normalized.indexOf(',') !== -1) {
      normalized = normalized.replace(/[.\s]/g, '').replace(',', '.');
    } else {
      normalized = normalized.replace(/\s/g, '');
    }
    var price = Number(normalized);
    return Number.isFinite(price) ? price : null;
  }

  function activeCurrency() {
    return clean(
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'EUR',
      3
    ).toUpperCase();
  }

  function listContext(card) {
    if (card.closest('cart-drawer')) {
      return { id: 'cart_drawer_recommendations', name: 'Cart drawer recommendations' };
    }

    var path = window.location.pathname;
    var collection = path.match(/^\/collections\/([^/?#]+)/);
    if (collection) {
      return {
        id: 'collection_' + clean(collection[1], 100),
        name: 'Collection: ' + clean(collection[1], 100)
      };
    }
    if (path.indexOf('/search') === 0) {
      return { id: 'search_results', name: 'Search results' };
    }
    if (path.indexOf('/products/') === 0) {
      return { id: 'product_recommendations', name: 'Product recommendations' };
    }
    if (path === '/' || path === '') {
      return { id: 'homepage_products', name: 'Homepage products' };
    }
    return { id: 'storefront_product_list', name: 'Storefront product list' };
  }

  function cardIndex(card) {
    var scope = card.closest('[id^="shopify-section-"], cart-drawer, main') || document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll(CARD_SELECTOR));
    var index = cards.indexOf(card);
    return index === -1 ? null : index + 1;
  }

  function itemFromCard(card, link) {
    var idNode = card.querySelector('[data-product-id]');
    var titleNode = card.querySelector(
      '.product-card__title, .vertical-product-card__title, .horizontal-product-card__title'
    );
    var priceNode = card.querySelector(
      '.product-card__price, .vertical-product-card__price, .horizontal-product-card__price'
    );
    var name = clean(
      titleNode && titleNode.textContent || link.getAttribute('aria-label') || link.textContent,
      200
    );
    var handle = productHandle(link);
    var id = clean(
      card.getAttribute('data-product-id') ||
      card.getAttribute('product-id') ||
      idNode && idNode.getAttribute('data-product-id') ||
      handle,
      120
    );
    var price = parsePrice(priceNode && priceNode.textContent);

    return compact({
      item_id: id,
      item_name: name || handle,
      price: price,
      index: cardIndex(card)
    });
  }

  function pagePath() {
    return clean(window.location.pathname, 180) || '/';
  }

  function publish(pixelEventName, ga4EventName, payload) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === 'function') {
      try {
        var result = analytics.publish(pixelEventName, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
        return;
      } catch (error) {
        // Use the direct GA4 fallback below when the customer-events bridge is unavailable.
      }
    }

    if (typeof window.gtag === 'function') {
      var directPayload = Object.assign({}, payload, {
        send_to: GA4_MEASUREMENT_ID,
        page_location: window.location.origin + pagePath()
      });
      delete directPayload.page_path;
      window.gtag('event', ga4EventName, directPayload);
    }
  }

  function handleProductSelection(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest(PRODUCT_LINK_SELECTOR);
    if (!link) return;
    var card = link.closest(CARD_SELECTOR);
    if (!card) return;

    var item = itemFromCard(card, link);
    if (!item.item_id && !item.item_name) return;
    var list = listContext(card);
    var payload = {
      item_list_id: list.id,
      item_list_name: list.name,
      currency: activeCurrency(),
      page_path: pagePath(),
      items: [item]
    };
    if (typeof item.price === 'number') payload.value = item.price;
    publish(PIXEL_SELECT_EVENT, 'select_item', payload);
  }

  function itemFromCart(line) {
    return compact({
      item_id: clean(line.product_id || line.id, 120),
      item_name: clean(line.product_title || line.title, 200),
      item_variant: clean(line.variant_title, 160),
      item_brand: clean(line.vendor, 120),
      price: Number(line.final_price || line.price || 0) / 100,
      quantity: Number(line.quantity || 1)
    });
  }

  function sendDrawerView() {
    if (window.location.pathname === '/cart') return;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        publish(PIXEL_CART_EVENT, 'view_cart', {
          currency: clean(cart.currency || activeCurrency(), 3).toUpperCase(),
          value: Number(cart.total_price || 0) / 100,
          cart_surface: 'drawer',
          page_path: pagePath(),
          items: cart.items.slice(0, 200).map(itemFromCart)
        });
      })
      .catch(function () {});
  }

  function drawerIsOpen(drawer) {
    return drawer.classList.contains('is-opened') ||
      drawer.hasAttribute('open') ||
      drawer.getAttribute('aria-hidden') === 'false';
  }

  function watchCartDrawer(drawer) {
    var wasOpen = drawerIsOpen(drawer);
    var observer = new MutationObserver(function () {
      var isOpen = drawerIsOpen(drawer);
      if (isOpen && !wasOpen) window.setTimeout(sendDrawerView, 100);
      wasOpen = isOpen;
    });
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden']
    });
  }

  function initializeStorefrontTracking() {
    if (initialized) return;
    initialized = true;
    document.addEventListener('click', handleProductSelection, true);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) watchCartDrawer(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStorefrontTracking);
  } else {
    initializeStorefrontTracking();
  }
})();
